import React, { useState } from 'react';
import { ArrowRight, Eye, EyeOff } from 'lucide-react';
import API from '../services/API';

// Đăng nhập một bước: SĐT + mật khẩu (PE_Form đi 2 bước vì có đăng ký đại lý; THM chưa cần).
const LoginPage = ({ onLogin }) => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const sdt = API.formatPhoneNumber(phone);
    if (!/^0\d{9}$/.test(sdt)) { setError('Số điện thoại phải 10 số, bắt đầu bằng 0'); return; }
    if (!password) { setError('Nhập mật khẩu'); return; }
    setLoading(true);
    try {
      const r = await API.login(sdt, password);
      if (r.success) onLogin(r.userInfo, r.accessToken);
      else setError(r.errorCode === 'INVALID_PASSWORD' ? 'Sai mật khẩu' : r.errorCode === 'USER_NOT_FOUND' ? 'Số điện thoại chưa có tài khoản' : r.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 to-brand-100 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-brand-500 text-white flex items-center justify-center text-2xl font-black shadow-lg">THM</div>
          <h1 className="mt-3 text-2xl font-bold text-gray-900">Tuệ Hải Minh</h1>
          <p className="text-sm text-gray-500">Đăng nhập bằng số điện thoại</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Số điện thoại</label>
            <input type="tel" inputMode="numeric" autoComplete="username" value={phone} onChange={(e) => setPhone(e.target.value)}
              placeholder="0912345678" className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-base" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mật khẩu</label>
            <div className="relative">
              <input type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Nhập mật khẩu" className="w-full px-4 py-3 pr-11 rounded-xl border border-gray-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-base" />
              <button type="button" onClick={() => setShowPassword((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" aria-label="Hiện/ẩn mật khẩu">
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
          <button type="submit" disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-brand-500 hover:bg-brand-600 text-white font-semibold disabled:opacity-60 transition-colors">
            {loading ? 'Đang đăng nhập...' : <>Đăng nhập <ArrowRight size={18} /></>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
